import { Component } from '@angular/core';

@Component({
  selector: 'app-offline-notification',
  template: `
    <span>You are offline — some features may not be available.</span>
  `,
  styles: [`
    span {
      color: #fff;
    }
  `]
})
export class OfflineNotificationComponent {

}
